<template>
  <div class="mb-4">
    <b-row>
      <b-col md="8">
        <span class="h3 pr-2">Przyjęte dostawy</span>
        <b-button v-b-toggle.filters variant="primary">Filtry</b-button>
      </b-col>
      <b-col md-4>
        <div class="float-right">
          <span>Ilość elementów na stronie: </span>
          <div class="btn-group" role="group" aria-label="Basic example">
            <button type="button" class="btn btn-primary" v-bind:class="{ active: filters.itemsPerPage == 10 }"
              @click="SetItemsPerPage(10)">
              10
            </button>
            <button type="button" class="btn btn-primary" v-bind:class="{ active: filters.itemsPerPage == 25 }"
              @click="SetItemsPerPage(25)">
              25
            </button>
            <button type="button" class="btn btn-primary" v-bind:class="{ active: filters.itemsPerPage == 50 }"
              @click="SetItemsPerPage(50)">
              50
            </button>
          </div>
        </div>
      </b-col>
    </b-row>
    <b-collapse id="filters" class="mt-4 w-100">
      <!--Filtrowanie po IDkach-->
      <b-row>
        <b-col>
          <label>Surowiec</label>
          <v-select label="name" :options="products" v-model="filters.rawMaterialTypeId"></v-select>
        </b-col>
        <b-col>
          <label>Dostawca</label>
          <v-select label="name" :options="producer" v-model="filters.producerId"></v-select>
        </b-col>
      </b-row>
      <!--Filtrowanie po datach-->
      <b-row>
        <b-col md="3">
          <label>Data dostawy od:</label>
          <b-form-datepicker id="DeliveryDateFrom" v-model="filters.deliveryDateFrom" class="mb-2"></b-form-datepicker>
        </b-col>
        <b-col md="3">
          <label>Data dostawy do:</label>
          <b-form-datepicker id="deliveryDateTo" v-model="filters.deliveryDateTo" class="mb-2"></b-form-datepicker>
        </b-col>
        <b-col md="3">
          <label>Data wystawienia faktury od:</label>
          <b-form-datepicker id="invoiceDateFrom" v-model="filters.invoiceDateFrom" class="mb-2"></b-form-datepicker>
        </b-col>
        <b-col md="3">
          <label>Data wystawienia faktury do:</label>
          <b-form-datepicker id="invoiceDateTo" v-model="filters.invoiceDateTo" class="mb-2"></b-form-datepicker>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <label>Rodzaj produktu</label>
          <v-select label="text" :options="rawMaterialTypes" v-model="filters.productType"  :reduce="(x) => x.value"></v-select>
        </b-col>
      </b-row>
      <b-row>
        <b-col offset="7" md="5">
          <button type="button" class="btn btn-primary float-right" @click="filterData()">
            Filtruj dane
          </button>
          <button type="button" class="btn btn-warning float-right mr-3" @click="cleanFilters()">
            Wyczyść filtry
          </button>
        </b-col>
      </b-row>
    </b-collapse>
  </div>
</template>
<script>
import deliveryMixins from "../../../mixins/delivery"

export default {
  name: "ReceivedDeliveryFilter",
  props: ["filters"],
  mixins: [deliveryMixins],
  computed: {
    products() {
      return this.$store.state.deliveryFormData.rawMaterialTypes;
    },
    producer() {
      return this.$store.state.deliveryFormData.producers;
    },
  },
  methods: {
    filterData() {
      this.$emit("FilterData")
    },
    cleanFilters() {
      this.$emit("CleanFilters")
    }
  }
};
</script>